import { useMapEvents } from "react-leaflet";
export const DragMapHandler = ({ setDragState }) => {
    const map = useMapEvents({
        dragend(e) {
            setDragState(true);
        },
    });
    return null;
};
